// extracted by mini-css-extract-plugin
export default {"error":"NotFound_error__KCb34","pulsate":"NotFound_pulsate__8uQzI"};